import { CommonModule } from '@angular/common'
import { Component, NgModule } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { TransactionMatching } from '@helios/common-api'
import { GenericComponentsModule } from '@helios/generic-components'
import { NgbActiveModal, NgbModalModule } from '@ng-bootstrap/ng-bootstrap'
import { NgSelectModule } from '@ng-select/ng-select'
import { TableLayoutModule } from '@northfork/ag-grid-angular'
import {
  ButtonModule,
  InlineEditModule,
  LoaderModule,
  NfFormsModule,
  ToastModule,
} from '@northfork/ng-basics'
import { EditTransactionTypeLabelComponent } from './edit-transaction-type-label/edit-transaction-type-label.component'
import { MoveToDifferentSleeveModalComponent } from './move-to-different-sleeve-modal/move-to-different-sleeve-modal.component'
import { SpecLotModalComponent } from './spec-lot-modal/spec-lot-modal.component'

@Component({
  selector: 'hs-unmatch-transaction-modal',
  template: ` <div class="modal-body">
      <h5>Which transaction type would you like to unmatch?</h5>
    </div>
    <div class="modal-footer">
      <button nf-button (click)="activeModal.dismiss()">Cancel</button>
      <button
        nf-button="primary"
        (click)="unmatch(transactionMatching.custody)"
        [attr.ngbAutofocus]="isEnfusionAccount ? true : null"
      >
        Custody
      </button>
      <button
        nf-button="primary"
        [disabled]="isEnfusionAccount"
        (click)="unmatch(transactionMatching.trading)"
      >
        Trading
      </button>
      <button
        nf-button="primary"
        [disabled]="isEnfusionAccount"
        (click)="unmatch(null)"
        [attr.ngbAutofocus]="!isEnfusionAccount ? true : null"
      >
        All
      </button>
    </div>`,
})
export class UnmatchTransactionModalComponent {
  transactionMatching = TransactionMatching
  isEnfusionAccount = false

  constructor(public activeModal: NgbActiveModal) {}

  unmatch(match: TransactionMatching | null) {
    this.activeModal.close(match)
  }
}

@NgModule({
  declarations: [
    UnmatchTransactionModalComponent,
    EditTransactionTypeLabelComponent,
    SpecLotModalComponent,
    MoveToDifferentSleeveModalComponent,
  ],
  imports: [
    CommonModule,
    NgbModalModule,
    ButtonModule,
    FormsModule,
    ReactiveFormsModule,
    NfFormsModule,
    GenericComponentsModule,
    NgSelectModule,
    ToastModule,
    TableLayoutModule,
    InlineEditModule,
    LoaderModule,
  ],
  exports: [UnmatchTransactionModalComponent, NgbModalModule],
})
export class TransactionModalModule {}
